import React from "react";
// Consumer Demand Forecasting

// Mui
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";

// Custom
import DashboardCard from "../card/DashboardCard";

// Theme
import theme from "../../theme";
import { Chip, Theme, SxProps } from "@mui/material";

const ConsumerDemandForecasting: React.FC = () => {
  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  const getChartContent = (
    total: string,
    color: string,
    description: string,
    chip: string,
    chipStyle?: SxProps<Theme>
  ) => {
    return (
      <Stack
        direction={"row"}
        alignItems={"center"}
        gap={"10px"}
        bgcolor={"#fafafa"}
        p={2}
        borderRadius={2}
        justifyContent={"space-between"}>
        <Stack direction={"row"} gap={"10px"} alignItems={"center"}>
          <Box
            className="consumer_demand_forecasting_chart_dots"
            sx={{ background: color }}></Box>
          <Box>
            <Typography fontSize={"20px"} lineHeight={"23px"} fontWeight={500}>
              {total}
              <Typography
                fontSize={"15px"}
                lineHeight={"18px"}
                fontWeight={400}
                color="#5F6368">
                kWh
              </Typography>
            </Typography>
            <Typography variant="body2" color="#5F6368">
              {description}
            </Typography>
          </Box>
        </Stack>
        <Chip label={chip} sx={chipStyle} />
      </Stack>
    );
  };

  return (
    <DashboardCard
      title={"Demand Forecasting"}
      sx={{
        p: "13px 18px 19px 15px",
        borderWidth: "1px",
        borderColor: "#E0E0E0",
        m: 2,
        mt: 4,
      }}
      body={
        <Box>
          <Stack
            direction={matches ? "column" : "row"}
            justifyContent={!matches ? "space-between" : "flex-start"}>
            <Stack
              direction={matches ? "row" : "column"}
              gap={matches ? "10px" : "10px"}
              mt={matches ? "10px" : "20px"}
              width={"100%"}>
              {getChartContent(
                "380",
                "linear-gradient(90deg, rgba(98, 217, 255, 0) 0%, rgba(98, 217, 255, 0.5) 50%, rgba(65, 177, 255, 0.75) 100%)",
                "Next Month Forecast",
                "Forecast",
                { backgroundColor: "#00dd0020" }
              )}
              {getChartContent(
                "370",
                "linear-gradient(90deg, rgba(2, 246, 250, 0) 0%, rgba(2, 246, 250, 0.5) 50%, rgba(0, 201, 204, 0.75) 100%)",
                "Actual Consumption",
                "Consumption",
                { backgroundColor: "#ff234320" }
              )}
              {getChartContent(
                "350",
                "linear-gradient(90deg, rgba(200, 204, 222, 0) 0%, rgba(200, 204, 222, 0.2) 29.08%, #C8CCDE 100%)",
                "Estimated Consumption",
                "Consumption",
                { backgroundColor: "#798cd820" }
              )}
            </Stack>
          </Stack>
        </Box>
      }
    />
  );
};

export default ConsumerDemandForecasting;
